// Site-wide SEO configuration
export const SITE_NAME = "Billing ECR POS";
export const REACT_APP_SITE_URL = process.env.REACT_APP_PUBLIC_SITE_URL || "https://billingecrpos.in";
export const SITE_DESCRIPTION =
  "R S Enterprises — Delhi-based dealer of ECR machines, POS systems, thermal printers and GST billing solutions since 2011. Genuine products from Essae, WEP, Trucount and more, with expert setup and support across India.";
export const SITE_IMAGE = `${REACT_APP_SITE_URL}/og-image.png`;

// Default SEO settings
export const DEFAULT_OG_IMAGE = {
  url: SITE_IMAGE,
  width: 1200,
  height: 630,
  alt: SITE_NAME,
};

// Social media usernames
export const SOCIAL = {
  // twitter: process.env.REACT_APP_PUBLIC_TWITTER_USERNAME || '',
  facebook: process.env.REACT_APP_PUBLIC_FACEBOOK_PAGE || "",
  // linkedin: process.env.REACT_APP_PUBLIC_LINKEDIN_COMPANY || '',
  instagram: process.env.REACT_APP_PUBLIC_INSTAGRAM_USERNAME || "",
};

// JSON-LD data for structured data
export const WEBSITE_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: REACT_APP_SITE_URL,
};

export const ORGANIZATION_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: REACT_APP_SITE_URL,
  logo: `${REACT_APP_SITE_URL}/logo.png`,
  // Only emit social profiles that are actually configured
  sameAs: [
    SOCIAL.facebook && `https://www.facebook.com/${SOCIAL.facebook}`,
    SOCIAL.instagram && `https://www.instagram.com/${SOCIAL.instagram}`,
  ].filter(Boolean),
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer service",
    email: process.env.REACT_APP_PUBLIC_CONTACT_EMAIL || "",
    url: `${REACT_APP_SITE_URL}/contact`,
  },
};

export const BREADCRUMB_JSON_LD = (
  items: Array<{ name: string; item: string }>,
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.item,
  })),
});

// Default meta keywords
export const DEFAULT_KEYWORDS = [
  "POS Machine for Retail",
  "Electronic Cash Register",
  "Retail Billing Machine",
  "ECR POS System",
  "POS Billing Solution",
  "Touchscreen Billing Machine",
  "ECR Billing System",
  "Retail POS Software",
  "Point of Sale Terminal",
  "Cash Register Machine",
  "Billing Machine for Shops",
  "Supermarket Billing POS",
  "Restaurant Billing System",
  "GST Billing Machine",
  "Barcode Scanner POS",
  "ECR Machines Delhi",
  "POS System India",
  "Retail Billing Solutions",
  "R S Enterprises POS",
  "Best ECR Machine Dealer",
  "Billing Machine",
  "Pos Systems",
  "Billing Software",
  "Retail Automation",
  "Payment Solutions",
  "Cash Drawer",
  "Printer",
  "Billing Hardware Repairs",
  "POS Terminal",
  "Billing Stationery",
  "Customized POS Solutions",
  "GST Billing",
  "ECR Machine Dealers in Delhi",
  "Buy Billing Machine Delhi",
  "Billing Machine India",
  "POS System Price India",
  "Best POS System for Retail India",
  "POS System for Small Shops Delhi",
  "POS Terminal India",
  "Retail Billing Software India",
  "Retail Billing Machine Supplier",
  "Retail Automation Solutions",
  "Customized POS Solutions India",
  "R S Enterprises Billing Solutions",
  "Billing Software India",
  "GST Billing Software India",
  "GST Billing Machine Supplier",
  "Payment Solutions India",
  "POS Receipt Printer India",
  "Cash Drawer India",
  "POS Hardware Supplier India",
  "Billing Hardware Repairs Delhi",
  "POS Repairs and Service Delhi",
  "Billing Stationery Supplier India",
  "POS Machine Near Me",
  "Best POS System India 2025",
];
